export enum CleverTapEventsCatalogCategory {
  webCatalogCategoryCreateCategory = 'Web_Catalog_Category_Create_Category',
  webCatalogCategoryEditCategory = 'Web_Catalog_Category_MM_Edit_Category',
  webCatalogCategoryDeleteCategory = 'Web_Catalog_Category_MM_Delete_Category',
  webCatalogCategoryCreateCategorySave = 'Web_Catalog_Category_Create_Category_Save_Clicked',
  webCatalogCategoryEditCategorySave = 'Web_Catalog_Category_Edit_Category_Save_Clicked',
  webCatalogCategoryEditCategoryDelete = 'Web_Catalog_Category_Edit_Category_Delete_Clicked',
  webCatalogCategorySearch = 'Web_Catalog_Category_Search'
}
